import {gsap} from "gsap";
import '../css/cursor.css';

const cursor = document.querySelector('.cursor');

const init = () => {

    if (!cursor){
        return;
    }

    const dot = document.querySelector('.cursor-dot');
    
    gsap.set('.cursor-imgs', { xPercent: -50, yPercent: -50 });

    let xTo = gsap.quickTo('.cursor-imgs', "left", { duration: .1, ease: "power2" });
    let yTo = gsap.quickTo('.cursor-imgs', "top", { duration: .1, ease: "power2" });

    window.addEventListener("mousemove", e => {
        xTo(e.clientX);
        yTo(e.clientY);
        
        gsap.set('.cursor-dot', {
            left: e.clientX,
            top: e.clientY
        });
        
    });
};

const initHovers = () => {

    const areaCursor = document.querySelectorAll('[data-cursor]');
    const allA = document.querySelectorAll('a, input, button, label, .accordion__trigger, textarea');

    cursor.removeAttribute('class');
    cursor.classList.add('cursor');
    cursor.classList.add('default');

    allA.forEach((a) => {

        a.addEventListener('mouseenter', function () {
            cursor.classList.add('over-a');
            cursor.classList.remove('default');
        });

        a.addEventListener('mouseleave', function () {
            cursor.classList.remove('over-a');
            cursor.classList.add('default');
        });
    });

    areaCursor.forEach((area) => {
        let cursorType = area.getAttribute('data-cursor');
        area.addEventListener('mouseenter', function () {
            cursor.classList.add(cursorType);
            cursor.classList.remove('default');
        });

        area.addEventListener('mouseleave', function () {
            cursor.classList.remove(cursorType);
            cursor.classList.add('default');
        });
    });
};

const initLoading = () => {
    cursor.classList.add('loading');
    cursor.classList.remove('default');
};

const endLoading = () => {
    cursor.classList.remove('loading');
    cursor.classList.add('default');
};

export default { init, initHovers, initLoading, endLoading };